/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { Colors } from 'utils';

const YoutubeIcon = ({ color, width, height }) => {
  return (
    <svg
      height={`${height || '24'}px`}
      width={`${width || '24'}px`}
      viewBox="0 0 24 24"
      css={css`
        fill: ${color || Colors.secondaryColor};
        max-width: ${width || '24'}px;
        max-height: ${height || '24'}px;
        height: ${height || '24'}px;
        width: ${width || '24'}px;
      `}
    >
      <g id="surface1">
        <path
          style={{
            stroke: 'none',
            fillRull: 'nonzero',
            fill: color || Colors.secondaryColor,
            fillOpacity: '1',
          }}
          d="M 18.398438 0 L 6.601562 0 C 2.898438 0 0 2.898438 0 6.601562 L 0 18.398438 C 0 22.101562 2.898438 25 6.601562 25 L 18.398438 25 C 22.101562 25 25 22.101562 25 18.398438 L 25 6.601562 C 25 2.898438 22.097656 0 18.398438 0 Z M 23.386719 18.398438 C 23.386719 21.195312 21.195312 23.386719 18.398438 23.386719 L 6.601562 23.386719 C 3.804688 23.386719 1.613281 21.195312 1.613281 18.398438 L 1.613281 6.601562 C 1.613281 3.804688 3.804688 1.613281 6.601562 1.613281 L 18.398438 1.613281 C 21.195312 1.613281 23.386719 3.804688 23.386719 6.601562 Z M 23.386719 18.398438 "
        />
        <path
          style={{
            stroke: 'none',
            fillRull: 'nonzero',
            fill: color || Colors.secondaryColor,
            fillOpacity: '1',
          }}
          d="M 20.363281 6.382812 C 20.101562 6.195312 19.757812 6.175781 19.480469 6.339844 C 19.203125 6.5 18.59375 6.582031 18.101562 6.644531 C 18 6.660156 17.902344 6.671875 17.804688 6.683594 C 17.117188 6.117188 16.242188 5.796875 15.335938 5.796875 C 13.300781 5.796875 11.628906 7.371094 11.511719 9.355469 C 9.664062 9.042969 7.972656 8.082031 6.773438 6.632812 C 6.597656 6.417969 6.320312 6.3125 6.042969 6.347656 C 5.765625 6.386719 5.527344 6.566406 5.414062 6.824219 C 5.363281 6.941406 4.914062 8.046875 4.914062 10.785156 C 4.914062 13.160156 6.785156 14.902344 8.070312 15.820312 C 7.191406 16.21875 6.179688 16.363281 5.21875 16.257812 C 4.839844 16.21875 4.488281 16.4375 4.367188 16.792969 C 4.242188 17.148438 4.378906 17.542969 4.695312 17.742188 C 6.210938 18.699219 7.964844 19.203125 9.765625 19.203125 C 15.546875 19.203125 19.042969 14.664062 19.171875 10.183594 C 19.339844 9.945312 19.65625 9.476562 20.191406 8.652344 C 20.40625 8.320312 20.585938 7.605469 20.675781 7.210938 C 20.746094 6.898438 20.621094 6.570312 20.363281 6.382812 Z M 17.71875 9.453125 C 17.621094 9.589844 17.566406 9.753906 17.566406 9.925781 C 17.566406 13.109375 15.144531 17.589844 9.765625 17.589844 C 9.277344 17.589844 8.796875 17.546875 8.324219 17.460938 C 8.953125 17.222656 9.550781 16.886719 10.097656 16.464844 C 10.316406 16.296875 10.433594 16.027344 10.410156 15.75 C 10.382812 15.476562 10.21875 15.234375 9.96875 15.109375 C 9.933594 15.089844 6.527344 13.296875 6.527344 10.789062 C 6.527344 9.945312 6.570312 9.285156 6.632812 8.78125 C 8.214844 10.144531 10.230469 10.960938 12.347656 11.066406 C 12.367188 11.066406 12.382812 11.066406 12.398438 11.066406 C 12.867188 11.050781 13.210938 10.707031 13.210938 10.257812 C 13.210938 10.148438 13.191406 10.042969 13.148438 9.945312 C 13.128906 9.824219 13.117188 9.703125 13.117188 9.582031 C 13.117188 8.382812 14.113281 7.410156 15.335938 7.410156 C 15.953125 7.410156 16.542969 7.660156 16.960938 8.097656 C 17.148438 8.296875 17.429688 8.386719 17.695312 8.335938 C 17.878906 8.300781 18.089844 8.273438 18.3125 8.242188 C 18.390625 8.234375 18.472656 8.222656 18.554688 8.210938 C 17.949219 9.132812 17.730469 9.4375 17.71875 9.453125 Z M 17.71875 9.453125 "
        />
      </g>
    </svg>
  );
};

export default YoutubeIcon;

YoutubeIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
